import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import store from './store.js';
import router from './router.js';

Vue.config.productionTip = false;

Vue.prototype.$vBus = new Vue();

var filter = function(text, length, clamp){
  clamp = clamp || '...';
  var node = document.createElement('div');
  node.innerHTML = text;
  var content = node.textContent;
  return content.length > length ? content.slice(0, length) + clamp : content;
};
Vue.filter('truncate', filter);


fetch('/atlas/config.json')
  .then(response => response.json())
  .then(config => {
    window.appConfig = config;

    new Vue({
      vuetify,
      store,
      router,
      render: h => h(App)
    }).$mount('#app');
  })
  .catch(err => {
    console.error('Nepavyko įkelti config.json:', err);
  });